import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './navbar/css/navbar.css'
import $ from 'jquery';
//import './navbar/js/navbar'

import AdminConfig from '../../containers/AdminConfig/AdminConfig'
import {
    BrowserRouter as Router,
    Route,
    Link,
    Redirect,
} from 'react-router-dom'

import i18n from "../../../../i18n";
import { translate, withNamespaces } from 'react-i18next'
import { deleteCookie,getMainCookie, setENSrcMap, setTHSrcMap } from '../../../util/util';

class MenuBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isTHLng: this.props.lng === 'th' || !this.props.lng
        };
    }
    componentDidMount() {
        let user=getMainCookie();
        console.log("user",user.user_level)
        if(!user.company_name)
            user.company_name="";
        this.setState({
            login_name:user.login_name,
            first_name:user.first_name,
            last_name:user.last_name,
            company_name:user.company_name,
            role:user.user_level==0?"(Owner)":user.user_level==1?"(Admin)":user.user_level==2?"(Dealer)":""
        });
        $(".prf-image").click(function () {
            $(".profile").toggle();
        });
        $(".profile .fa-times").click(function () {
            $(".profile").toggle();
        });

    }
    onSwitchLng() {

        if (this.props.lng === 'th'){
            setENSrcMap();
            i18n.changeLanguage('en');
        }
        else{
            setTHSrcMap();
            i18n.changeLanguage('th');
        }
        this.state.isTHLng = !(this.props.lng == 'th');
        console.log('MenuBar onSwitchLng', this.props.lng, this.state.isTHLng);
    }

    // state = {
    //     isMonitorPage:" active",
    //     isAdminConfigPage: "",

    // }
    // chkAdminConfigPage = () => {
    //     this.setState(() => ({
    //         isMonitorPage: "",
    //         isAdminConfigPage:" active"
    //     }))


    // }
    // chkMonitorPage = () => {
    //     this.setState(() => ({
    //         isMonitorPage: true
    //     }))

    // }

    render() {


        // const { isAdminConfigPage,isMonitorPage } = this.state

        // console.log("page",isMonitorPage,isAdminConfigPage);
        // if (isAdminConfigPage === true) {
        //         return(   <Link to='/admin_config' />     );
        // }else if (isMonitorPage === true) {
        //     return(   <Link to='/monitor' />     );
        // }
        let { tab_monitor, tab_adminconf, tab_maintenance, tab_report, t ,tab_main,tab_payment} = this.props;
        let { isTHLng,company_name,login_name,first_name,last_name,role } = this.state;
        console.log("user", role);
        return (

            <div className="menubar">
                <div className="row ">
                    <div className="col-xd-12 col-md-11 ">
                        <nav className="navbar navbar-expand-lg custom-navbar navbar-dark  navbar-light bg-light">
                            <div className="navbar-brand">
                            <Link to='/monitor'><img src="./images/logo/Fastrack-Logo2.png" /></Link>
                        </div>
                            <button className="navbar-toggler navbar-toggler-right hidden-lg-up" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                                <i className="fa fa-bars" aria-hidden="true">{''}</i>
                            </button>
                            <div className="collapse navbar-collapse navbar-toggleable-md nav-tabs " id="collapsibleNavbar">
                                <ul className="navbar-nav mr-auto" style={{ paddingLeft: 10 }}>
                                    <Link to='/main' className={"nav-item nav-link " + tab_main} href="#"  ><i className="fas fa-star-of-life">{''}</i> {t('ภาพรวม')}</Link>
                                    <Link to='/monitor' className={"nav-item nav-link " + tab_monitor} href="#"  ><i className="fas fa-map-marker-alt">{''}</i> {t('เฝ้าสังเกต')}</Link>
                                    <Link to='/report' className={`nav-item nav-link ${tab_report}`}><i className="fas fa-file-contract">{''}</i> {t('รายงาน')}</Link>
                                    <Link to='/admin_config' className={"nav-item nav-link " + tab_adminconf} onClick={this.chkAdminConfigPage}><i className="fas fa-users-cog">{''}</i> {t('จัดการข้อมูล')}</Link>
                                    <Link to='/maintenance' className={`nav-item nav-link ${tab_maintenance}`} ><i className="fas fa-wrench">{''}</i> {t('ระบบซ่อมบำรุง')}</Link>
                                    <Link to='/payment' className={"mobile-close  nav-item nav-link "+tab_payment} href="#"><i className="fas fa-credit-card">{''}</i> {t('ชำระเงิน')}</Link>
                                    <Link to='/commingsoon' className="nav-item nav-link" href="#"><i className="fas fa-book">{''}</i> {t('คู่มือ')}</Link>

                                </ul>
                                <ul className="navbar-nav" style={{ paddingLeft: 10 }}>
                                    <li>
                                        <ul>
                                            <Link to='/' onClick={deleteCookie.bind(this, 'ft')} className="d-block d-sm-block d-md-none"><i className="fa fa-power-off log-out" style={{ marginTop: 10 }} /></Link>
                                            <div className="onoffswitch3" >
                                                <input onClick={this.onSwitchLng.bind(this)} type="checkbox" name="onoffswitch3" className="onoffswitch3-checkbox" id="myonoffswitch3" defaultChecked={isTHLng} />
                                                <label className="onoffswitch3-label" htmlFor="myonoffswitch3">
                                                    <span className="onoffswitch3-inner">
                                                        <span className="onoffswitch3-active">
                                                            <span className="onoffswitch3-switch">ไทย{/*<p>eng</p>*/}</span>

                                                        </span>
                                                        <span className="onoffswitch3-inactive"><span className="onoffswitch3-switch">{/*<p>ไทย</p>*/}ENG</span></span>
                                                    </span>
                                                </label>

                                            </div>
                                        </ul>
                                    </li>

                                </ul>


                            </div>
                        </nav>
                    </div>
                    <div className=" col-md-1 navbar-fix d-none d-md-block">
                        <form className="form-inline ml-auto pull-right" >
                            <div className="prf-image">
                                <i className="fa fa-ellipsis-v " style={{ fontSize: 20, marginRight: 20, top: 5, position: 'relative' }} aria-hidden="true"></i>
                                <img src="./images/temp/user.png" className="rounded-circle" style={{ width: 30 }} />
                            </div>


                        </form>
                        <div className="profile" style={{ display: 'none' }}>


                            <div className="detail-cover" >
                                <span className="fa fa-times"  style={{position: 'absolute',right: 20,top: 65,cursor:'pointer'}}/>
                                <div style={{ position: 'relative', marginTop: 50 }}>
                                    <div className="arrow-up2" />
                                    <div className="arrow-up" />
                                </div>
                                <div className="detail">

                                    <div className="detail-image"><img src="./images/temp/user.png" className="img-thumbnail" style={{ width: 95 }} /></div>
                                    <h3>{login_name} <font style={{color:"#adaaaa" ,fontWeight:"normal",fontSize:12}}>{role}</font></h3>
                                    <h5>{first_name?first_name:" " + " " + (last_name?last_name:" ")}</h5>
                                    <h4>{company_name}</h4>
                                    <Link to='/' onClick={deleteCookie.bind(this, 'ft')}><i className="fa fa-power-off log-out" /></Link>
                                    <ul className="profile-button" > 
                                        <li id="view-profile"><Link to='/admin_config'>แก้ไขข้อมูล  <i className="fa fa-cog" /></Link></li>

                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>



        );
    }
}
MenuBar.propTypes = {
    tab_monitor: PropTypes.string,
    tab_adminconf: PropTypes.string,
    tab_maintenance: PropTypes.string,
    tab_report: PropTypes.string
};

MenuBar.defaultProps = {
    tab_monitor: '',
    tab_adminconf: '',
    tab_maintenance: '',
    tab_report: ''
};
export default withNamespaces('Menubar')(MenuBar);



// WEBPACK FOOTER //
// ./src/app/view/components/MenuBar/MenuBar.js